function updateIframe() {
  const trackerWrapper = document.querySelector(".custom-track-order-wrapper");
  const messageEl = document.querySelector(".custom-track--order-message");
  const inputEl = document.getElementById("awbInput");

  trackerWrapper.style.display = "none";
  messageEl.style.display = "none";

  const input = inputEl.value.trim();

  if (!input) {
    alert("Please enter an Order ID or AWB tracking number");
    return;
  }

  // NX validation (keep this if business requires it)
  if (!input.toUpperCase().startsWith("NX") || input.length < 5) {
    messageEl.style.display = "block";
    messageEl.textContent = "Invalid tracking ID";
    return;
  }

  fetch(`https://bluedart.marmeto.com/api/order_number/${input}?store=nexxus`)
    .then(res => res.json())
    .then(result => {
      const normalized = getNormalizedShipment(result);

      //  console.log("Order on",result.data.tracking_data.shipment_track[0].updated_time_stamp);
      if (!normalized) {
        console.log(result);
        messageEl.style.display = "block";
        messageEl.textContent = result.message;
        return;
      }

      const {
        scans,
        status,
        eta,
        pickupDate,
        trackingUrl,
        scanTextGetter
      } = normalized;

      trackerWrapper.style.display = "block";
      messageEl.style.display = "none";

      // Tracking URL
      const linkElement = document.querySelector(".tracking_url_container");
      if (linkElement && trackingUrl) {
        linkElement.href = trackingUrl;
      }

      // Reset steps
      const steps = document.querySelectorAll(".delivery_status__step");
      steps.forEach(step => step.classList.remove("completed"));

      // Step 1: Order confirmed
      steps[0]?.classList.add("completed");

      let isInTransit = false;
      let isOutForDelivery = false;

      scans.forEach(s => {
        const text = scanTextGetter(s);

        if (
          text.includes("picked up") ||
          text.includes("arrived") ||
          text.includes("connected") ||
          text.includes("in transit")
        ) {
          isInTransit = true;
        }

        if (text.includes("out for delivery")) {
          isOutForDelivery = true;
        }
      });

      const delivered = status.toLowerCase().includes("delivered");

      if (isInTransit || isOutForDelivery || delivered) {
        steps[1]?.classList.add("completed");
      }

      if (isOutForDelivery || delivered) {
        steps[2]?.classList.add("completed");
      }

      if (delivered) {
        steps[3]?.classList.add("completed");
      }

      // Status text (last completed step)
      let statusText = "Order Confirmed";
      const completedSteps = [...steps].filter(s =>
        s.classList.contains("completed")
      );
      if (completedSteps.length) {
        statusText =
          completedSteps[completedSteps.length - 1].textContent.trim();
      }

      // ETA handling
      const deliveryWrapper = document.querySelector(
        ".custom-track-order-delivery-wrapper"
      );

      let etaDate = null;
      if (eta) {
        etaDate = new Date(eta);
        if (isNaN(etaDate)) {
          etaDate = new Date(Date.parse(eta)); // Blue Dart fallback
        }
      }

      document.querySelector(".to-delivery-status").textContent = statusText;

      if (delivered || !etaDate || isNaN(etaDate)) {
        deliveryWrapper.style.display = "none";
      } else {
        document.querySelector(".to-delivery-date").textContent =
          etaDate.getDate();
        document.querySelector(".to-delivery-month").textContent =
          etaDate.toLocaleString("default", { month: "long" });
        document.querySelector(".to-deliver-year").textContent =
          etaDate.getFullYear();
        deliveryWrapper.style.display = "block";
      }

      document.querySelector(".order-id-display").textContent = input;
      document.querySelector(".pickup-date-display").textContent =
        formatDate(pickupDate);
    })
    .catch(err => {
      console.error("Tracking error:", err);
      messageEl.style.display = "block";
      messageEl.textContent =
        "Something went wrong while fetching tracking details. Please try again.";
    });
}

/* ---------------- NORMALIZATION LAYER ---------------- */

function getNormalizedShipment(result) {
  // debugger;
  const courier = result?.courier;

  // DELHIVERY
  if (courier === "DELHIVERY") {
    const shipment = result?.data?.ShipmentData?.[0]?.Shipment;
    if (!shipment) return null;

    return {
      scans: shipment.Scans || [],
      status: shipment.Status?.Status || "",
      eta: shipment.ExpectedDeliveryDate || "",
      pickupDate: shipment.PickUpDate || shipment.Status?.StatusDateTime,
      trackingUrl: result.tracking_url,
      scanTextGetter: s =>
        s?.ScanDetail?.Instructions?.toLowerCase() || ""
    };
  }

  // BLUEDART
  if (courier === "BLUEDART") {
    const shipment = result?.data?.ShipmentData?.Shipment?.[0];
    if (!shipment) return null;

    return {
      scans: shipment.Scans || [],
      status: shipment.Status || "",
      eta: shipment.ExpectedDelivery || "",
      pickupDate: shipment.PickUpDate,
      trackingUrl: result.tracking_url,
      scanTextGetter: s =>
        s?.ScanDetail?.Scan?.toLowerCase() || ""
    };
  }

  // SHIPROCKET
  if (courier === "SHIPROCKET" || courier === "Shiprocket") {
    // debugger;
    const trackingData = result?.data?.tracking_data;
    const shipment = trackingData?.shipment_track?.[0];

    if (!trackingData || !shipment) return null;

    return {
      scans: trackingData?.shipment_track_activities || [],
      status: shipment?.current_status || "",
      eta: shipment?.edd || trackingData?.etd || "",
      pickupDate: shipment?.updated_time_stamp || "",
      trackingUrl: result.tracking_url || trackingData?.track_url,

      // normalize scan text
      scanTextGetter: s =>
        s?.activity?.toLowerCase() || ""
    };
  }

  return null;
}

/* ---------------- DATE FORMATTER ---------------- */

function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}
